import { useEffect } from "react";
import SubscriptionUpgradePanel from "./SubscriptionUpgradePanel";

interface SubscriptionUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Product permission whose plans are offered. */
  permission?: string;
}

/**
 * Modal shell around {@link SubscriptionUpgradePanel}. The panel is the same
 * component rendered on the `/subscriptions` page, so the two stay identical.
 */
const SubscriptionUpgradeModal = ({
  isOpen,
  onClose,
  permission,
}: SubscriptionUpgradeModalProps) => {
  // Close on Escape.
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <SubscriptionUpgradePanel permission={permission} onClose={onClose} />
    </div>
  );
};

export default SubscriptionUpgradeModal;
